// Shared relative-time helper: "just now" / "N min ago" / "Nh ago" / "Nd ago",
// falling back to a locale date string beyond 30 days. Pure (no React/DOM state),
// so it lives in lib/ for reuse + easy unit testing.
export function relativeTime(iso: string): string {
  const d = new Date(iso);
  const diffMs = Date.now() - d.getTime();
  const mins = Math.round(diffMs / 60_000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d ago`;
  return d.toLocaleDateString(navigator.language);
}
